<template>
  <div :style="style" class="bg-color border flex flex-col space-y-3">
    <div v-if="loading" class="flex flex-col pt-3 px-3 space-y-3">
      <div class="space-y-1">
        <div class="h-10 animate-pulse">
          <div class="h-full bg-gray-200 rounded"></div>
        </div>
      </div>
      <div class="h-3 animate-pulse">
        <div class="h-full bg-gray-200 rounded"></div>
      </div>
    </div>
    <div v-else class="flex flex-col pt-3 px-3 space-y-4">
      <div class="space-y-1">
        <h3
          class="title-color font-bold line-clamp text-lg"
          :data-id="params.location_id"
        >
          {{ params.name }}
        </h3>
        <span
          class="subtitles-color block text-xs font-bold line-clamp"
          v-if="params.address"
          >{{ params.address }}</span
        >
        <span
          class="subtitles-color block text-xs font-bold line-clamp"
          v-else-if="params.contact_no"
          >{{ params.contact_no }}</span
        >
      </div>
      <span
        v-if="params.formmatted_distance"
        class="subtitles-color block text-xs line-clamp"
        >{{ params.formmatted_distance }}</span
      >
    </div>
    <div class="space-y-1">
      <div class="h-1 bg-gray-50 relative">
        <div v-if="loading" class="absolute bg-gray-200 h-1 w-1/3"></div>
        <div v-else class="absolute divider-color h-1 w-full"></div>
      </div>
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    params: {
      type: Object,
      default: () => {},
    },
    loading: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    style() {
      return {
        "--bg-color":
          this.$store.state.config.colors.samedayCardBackground || "#FFFFFF",
        "--border-color":
          this.$store.state.config.colors.samedayCardBorderColor || "#E5E7EB",
        "--title-color":
          this.$store.state.config.colors.samedayCardTitleColor || "#212127",
        "--subtitles-color":
          this.$store.state.config.colors.samedayCardSubtitlesColor ||
          "#9CA3AF",
        "--divider-color":
          this.$store.state.config.colors.samedayCardDividerColor || "#212127",
      };
    },
  },
};
</script>

<style scoped>
.line-clamp {
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
}
.bg-color {
  background-color: var(--bg-color);
  border-color: var(--border-color);
}
.title-color {
  color: var(--title-color);
}
.subtitles-color {
  color: var(--subtitles-color);
}
.divider-color {
  background-color: var(--divider-color);
}
</style>
